import { Search } from '@components/search'
import * as css from './style'

export const Toolbar = ({ onChangeFilter }) => {
  return (
    <css.Toolbar role="toolbar" aria-label="Template toolbar controls">
      <Search onChange={onChangeFilter} />
    </css.Toolbar>
  )
}
